// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"22":"52ed9727","480":"7a58fb0b","604":"b8a0cb05","739":"20256359","851":"a55223c5","905":"45883d39","972":"575ad924"}[chunkId] + ".js";
};